function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import map from 'lodash/map';
import { MedicalRecordContext } from 'context';
import { formatDate } from 'helpers/datetime';
import MetricConversions from 'libs/MetricConversions';
import Widget from 'components/Widget';
import Avatar from 'components/Avatar';
import App from 'modules/App';
import Account from 'modules/Account';
import { MobileBloodGlucoseConcentrationReport, MobileDailyLogReport } from 'modules/MobileReports';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import { Indicators } from '../../modules/Kpi';
import MeasurementsTableWidget from '../MeasurementsTableWidget';
import GlucoseLevelDistributionWidget from '../GlucoseLevelDistributionWidget';
import SummaryTableWidgetReport from '../SummaryTableWidgetReport';
import TrendChartWidget from '../TrendChartWidget';
import AgpTrendChartWidget from '../AgpTrendChartWidget';
import PrintableAgpBgmReport from '../PrintableAgpBgmReport';
import DailyLogReport from '../DailyLogReport';
import BloodGlucoseConcentrationReport from '../BloodGlucoseConcentrationReport';
import GlucoseConcentrationLevelsWidget from '../Widgets/GlucoseConcentrationLevelsWidget';
import PatientsBgDataReport from '../PatientsBgDataReport';
import PatientGestationalReport from '../PatientGestationalReport';
import styles from './Report.pcss';
var _React_PureComponent;
class Report extends (_React_PureComponent = React.PureComponent) {
    get customRanges() {
        const customRanges = get(this.props.reportsState.phiSet, 'customRanges');
        if (!customRanges) return map(constants.HOURS_BREAKPOINTS, (hb)=>[
                ...hb
            ]);
        if (JSON.stringify(customRanges) === JSON.stringify([
            [
                0,
                0
            ]
        ])) {
            return map(constants.NEW_CDA_HOURS_BREAKPOINTS, (hb)=>[
                    ...hb
                ]);
        }
        return customRanges;
    }
    /* eslint-disable react/no-unstable-nested-components */ get widgets() {
        const { reportsState, hideReadingsTable } = this.props;
        const startDate = moment.utc(reportsState.startDate);
        const endDate = moment.utc(reportsState.endDate);
        return {
            TrendChartWidget: ()=>{
                switch(this.props.deviceMode){
                    case 'BGM':
                        return /*#__PURE__*/ _jsx(TrendChartWidget, {
                            renderControls: false,
                            className: "TrendChartWidget",
                            data: this.statsData,
                            dataType: "BGM",
                            relatedData: reportsState.relatedData,
                            timeSeriesResources: reportsState.timeSeriesResources,
                            measurements: reportsState.measurements,
                            start: reportsState.start,
                            end: reportsState.end,
                            conversion: this.metricConversions.bloodGlucoseConcentration,
                            direction: this.props.direction,
                            standards: reportsState.standards,
                            customRanges: this.customRanges,
                            activePointTimestamp: reportsState.activeMeasurementTimestamp,
                            isInProgress: false,
                            isReadOnly: true,
                            highlightedReadings: reportsState.highlightedReadings,
                            onSetActivePointTimestamp: ()=>null
                        }, "TrendChartWidget");
                    case 'AGP':
                        return /*#__PURE__*/ _jsx(AgpTrendChartWidget, {
                            className: "AgpTrendChartWidget",
                            conversion: this.metricConversions.bloodGlucoseConcentration,
                            direction: this.props.direction,
                            standards: reportsState.standards,
                            isInProgress: false,
                            start: reportsState.start,
                            end: reportsState.end,
                            data: this.statsData
                        }, "AgpTrendChartWidget");
                    default:
                        return null;
                }
            },
            MeasurementsTableWidget: ()=>!hideReadingsTable && /*#__PURE__*/ _jsx(MeasurementsTableWidget, {
                    className: "MeasurementsTableWidget",
                    phiSet: reportsState.phiSet,
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    readings: reportsState.data,
                    timeSeriesResources: reportsState.timeSeriesResources,
                    relatedData: reportsState.relatedData,
                    customRanges: this.customRanges,
                    activeReadingTimestamp: reportsState.activeMeasurementTimestamp,
                    headerMessage: messages.headers.measurementsTable,
                    isInProgress: reportsState.isInProgress,
                    isReadOnly: true
                }, "MeasurementsTableWidget"),
            GlucoseLevelDistributionWidget: ()=>/*#__PURE__*/ _jsx(GlucoseLevelDistributionWidget, {
                    className: "GlucoseLevelDistributionWidget",
                    flagFilters: reportsState.flagFilters,
                    standards: reportsState.standards,
                    readings: reportsState.data,
                    isInProgress: reportsState.isInProgress
                }, "GlucoseLevelDistributionWidget"),
            SummaryTableWidgetReport: ()=>/*#__PURE__*/ _jsx(SummaryTableWidgetReport, {
                    className: "SummaryTableWidgetReport",
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    readings: reportsState.data,
                    customRanges: this.customRanges,
                    isInProgress: reportsState.isInProgress
                }, "SummaryTableWidgetReport"),
            PatientHeader: ()=>this.renderPrintableHeader(),
            BloodGlucoseConcentrationReport: ()=>/*#__PURE__*/ _jsx(BloodGlucoseConcentrationReport, {
                    className: "BloodGlucoseConcentrationReport",
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    calculationFormula: reportsState.calculationFormula,
                    phiSet: reportsState.phiSet,
                    measurements: reportsState.measurements,
                    accountPatientProfile: reportsState.accountPatientProfile,
                    customRanges: this.customRanges
                }, "BloodGlucoseConcentrationReport"),
            DailyLogReportPrint: ()=>/*#__PURE__*/ _jsx(DailyLogReport, {
                    className: "DailyLogReportPrint",
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    calculationFormula: reportsState.calculationFormula,
                    phiSet: reportsState.phiSet,
                    accountPatientProfile: reportsState.accountPatientProfile,
                    startDate: startDate,
                    endDate: endDate,
                    readings: reportsState.data,
                    relatedData: reportsState.relatedData,
                    daysWithReadings: reportsState.daysWithReadings,
                    daysWithoutReadings: reportsState.daysWithoutReadings,
                    preMeal: reportsState.preMeal,
                    postMeal: reportsState.postMeal,
                    hideEmptyRows: this.props.hideEmptyRows,
                    hideDailyDetails: this.props.hideDailyDetails,
                    showDayDividers: this.props.showDayDividers,
                    customRanges: this.customRanges,
                    timeSeriesResources: reportsState.timeSeriesResources
                }, "DailyLogReportPrint"),
            NewCDADailyLogReport: ()=>/*#__PURE__*/ _jsx(MobileDailyLogReport, {
                    className: "DailyLogReportPrint",
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    carbsConversion: this.metricConversions.carbs,
                    standards: reportsState.standards,
                    calculationFormula: reportsState.calculationFormula,
                    phiSet: reportsState.phiSet,
                    accountPatientProfile: reportsState.accountPatientProfile,
                    startDate: startDate,
                    endDate: endDate,
                    readings: reportsState.data,
                    direction: this.props.direction,
                    relatedData: reportsState.relatedData,
                    daysWithReadings: reportsState.daysWithReadings,
                    daysWithoutReadings: reportsState.daysWithoutReadings,
                    preMeal: reportsState.preMeal,
                    postMeal: reportsState.postMeal,
                    hideEmptyRows: this.props.hideEmptyRows,
                    showDayDividers: this.props.showDayDividers,
                    customRanges: this.customRanges,
                    timeSeriesResources: reportsState.timeSeriesResources
                }, "NewCDADailyLogReport"),
            NewCDABloodGlucoseConcentrationReport: ()=>/*#__PURE__*/ _jsx(MobileBloodGlucoseConcentrationReport, {
                    className: "BloodGlucoseConcentrationReport",
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    calculationFormula: reportsState.calculationFormula,
                    phiSet: reportsState.phiSet,
                    endDate: endDate,
                    measurements: reportsState.measurements,
                    accountPatientProfile: reportsState.accountPatientProfile,
                    customRanges: this.customRanges
                }, "NewCDABloodGlucoseConcentrationReport"),
            GlucoseConcentrationLevelsWidget: ()=>/*#__PURE__*/ _jsx(GlucoseConcentrationLevelsWidget, {
                    className: "GlucoseConcentrationLevelsWidget",
                    readings: reportsState.data
                }, "GlucoseConcentrationLevelsWidget"),
            PrintableAgpBgmReport: ()=>{
                const { preMealReadings, postMealReadings, strictPreMealReadings, strictPostMealReadings, data, daysWithReadings, daysWithoutReadings, readingsWithoutFlag } = reportsState.agpData;
                return /*#__PURE__*/ _jsx(PrintableAgpBgmReport, {
                    className: "PrintableAgpBgmReport",
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    firstName: get(reportsState.accountPatientProfile, 'firstName', ''),
                    lastName: get(reportsState.accountPatientProfile, 'lastName', ''),
                    readings: data,
                    preMealReadings: preMealReadings,
                    postMealReadings: postMealReadings,
                    strictPreMealReadings: strictPreMealReadings,
                    strictPostMealReadings: strictPostMealReadings,
                    daysWithReadings: daysWithReadings,
                    daysWithoutReadings: daysWithoutReadings,
                    readingsWithoutFlag: readingsWithoutFlag,
                    glucoseConcentrationLevelBottomValues: constants.GLUCOSE_CONCENTRATION_LEVELS_BOTTOM_VALUES
                }, "PrintableAgpBgmReport");
            },
            PatientsBgDataReport: ()=>/*#__PURE__*/ _jsx(PatientsBgDataReport, {
                    downloadCsv: this.props.downloadCsv,
                    isMobileDisplayMode: this.props.isMobileDisplayMode,
                    className: "PatientsBgDataReport",
                    locale: this.props.locale,
                    carbsConversion: this.metricConversions.carbs,
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    readings: reportsState.data,
                    relatedData: reportsState.relatedData,
                    timeSeriesResources: reportsState.timeSeriesResources,
                    accountPatientProfile: reportsState.accountPatientProfile,
                    startDate: startDate,
                    endDate: endDate
                }, "PatientsBgDataReport"),
            PatientsGestationalReport: ()=>/*#__PURE__*/ _jsx(PatientGestationalReport, {
                    className: "PatientGestationalReport",
                    accountPatientProfile: reportsState.accountPatientProfile,
                    conversion: this.metricConversions.bloodGlucoseConcentration,
                    standards: reportsState.standards,
                    phiSet: reportsState.phiSet,
                    readings: reportsState.data,
                    reportsDates: {
                        startDate,
                        endDate,
                        days: reportsState.days
                    }
                }, "PatientGestationalReport")
        };
    }
    get statsData() {
        const { reportsState } = this.props;
        const { statsData, data } = reportsState;
        return statsData || data;
    }
    renderFeatures() {
        const { reportsState } = this.props;
        const { data: readings, preMealReadings, postMealReadings, daysWithReadings, daysWithoutReadings, readingsWithoutFlag } = reportsState;
        return /*#__PURE__*/ _jsx(Indicators, {
            readings: readings,
            preMealReadings: preMealReadings,
            postMealReadings: postMealReadings,
            daysWithReadings: daysWithReadings,
            daysWithoutReadings: daysWithoutReadings,
            readingsWithoutFlag: readingsWithoutFlag
        }, "KPI");
    }
    renderPrintablePatient() {
        const { firstName, lastName } = this.props.reportsState.accountPatientProfile || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: "col p-4",
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: cn('text--h3', styles.reportInfo__label),
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.info))
                }),
                /*#__PURE__*/ _jsxs("p", {
                    className: "text--h1 mb-2",
                    children: [
                        /*#__PURE__*/ _jsxs("span", {
                            children: [
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.for)),
                                /*#__PURE__*/ _jsx("br", {})
                            ]
                        }),
                        `${firstName} ${lastName}`
                    ]
                })
            ]
        });
    }
    renderPrintableHeader() {
        const { activeClinicMembership, reportsState } = this.props;
        const { startDate, endDate, days } = reportsState;
        const clinic = get(activeClinicMembership, 'clinic');
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                clinic && /*#__PURE__*/ _jsx(Widget, {
                    widgetId: constants.CLINIC_HEADER_WIDGET,
                    isNoHeader: true,
                    className: styles.printableClinicDetailsWrapper,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "row align-items-center",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: styles.printableClinicDetails,
                            children: [
                                /*#__PURE__*/ _jsx(Avatar, {
                                    imgClassName: styles.printableClinicDetails__logo,
                                    avatarImg: clinic.logo
                                }),
                                /*#__PURE__*/ _jsxs("p", {
                                    className: cn('text--normal', styles.printableClinicDetails__info),
                                    children: [
                                        clinic.name,
                                        /*#__PURE__*/ _jsx("br", {}),
                                        clinic.street,
                                        /*#__PURE__*/ _jsx("br", {}),
                                        clinic.zipCode,
                                        " ",
                                        clinic.city
                                    ]
                                })
                            ]
                        })
                    })
                }, "clinic-header"),
                /*#__PURE__*/ _jsx(Widget, {
                    widgetId: constants.PATIENT_HEADER_WIDGET,
                    isNoHeader: true,
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: styles.printableHeader,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "row align-items-center",
                                children: this.renderPrintablePatient()
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: styles.printableHeaderFeatures,
                                    children: this.renderFeatures()
                                })
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: styles.reportInfo__time,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.report.generated)),
                                            ' ',
                                            moment().format('ll')
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            formatDate(startDate, 'll'),
                                            " - ",
                                            formatDate(endDate, 'll'),
                                            "(",
                                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.presets.days), {
                                                values: {
                                                    number: days
                                                }
                                            })),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, "patient-header")
            ]
        }, "patient-header-wrapper");
    }
    renderWidgets() {
        if (!process.env.BROWSER) {
            return null;
        }
        const { dashboardLayout } = this.props;
        return map(dashboardLayout, (widget)=>{
            if (Array.isArray(widget)) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "row",
                    children: map(widget, (element)=>{
                        const items = element.split(';');
                        return /*#__PURE__*/ _jsx("div", {
                            className: items[0],
                            children: this.widgets[items[1]] ? this.widgets[items[1]]() : null
                        }, `item-${items[1]}`);
                    })
                }, `${widget.toString()}`);
            }
            return this.widgets[widget] ? this.widgets[widget]() : null;
        });
    }
    render() {
        const { reportsState } = this.props;
        return /*#__PURE__*/ _jsx(MedicalRecordContext.Provider, {
            value: reportsState.accountPatientProfile,
            children: /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("div", {
                    className: cn('widgets', 'widgets--noGutters', styles.root),
                    children: this.renderWidgets()
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.metricConversions = new MetricConversions(props.metricsUnits);
    }
}
_define_property(Report, "propTypes", {
    // Explicit props
    dashboardLayout: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])).isRequired,
    downloadCsv: PropTypes.bool,
    hideReadingsTable: PropTypes.bool,
    hideDailyDetails: PropTypes.bool,
    hideEmptyRows: PropTypes.bool,
    showDayDividers: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    clinicSettings: PropTypes.object,
    // Implicit props
    deviceMode: PropTypes.oneOf(constants.DEVICES_MODES),
    calculationFormula: PropTypes.oneOf([
        ...constants.CALCULATION_FORMULAS,
        ...constants.CALCULATION_FORMULAS_CGM
    ]),
    reportsState: PropTypes.object,
    direction: App.shapes.direction,
    locale: PropTypes.string,
    metricsUnits: PropTypes.object,
    activeClinicMembership: Account.shapes.clinicMembership,
    isMobileDisplayMode: PropTypes.bool
});
const mapStateToProps = (state)=>({
        deviceMode: selectors.deviceMode(state),
        calculationFormula: selectors.calculationFormula(state),
        reportsState: selectors.reportsState(state),
        locale: App.selectors.locale(state),
        direction: App.selectors.direction(state),
        metricsUnits: Account.selectors.metricsUnits(state),
        activeClinicMembership: Account.selectors.activeClinicMembership(state),
        isMobileDisplayMode: App.selectors.isMobileDisplayMode(state)
    });
const ConnectedReport = connect(mapStateToProps, null)(injectIntl(Report));
export default withStyles(styles)(ConnectedReport);
